<template>
  <html>
    <head>
      <meta charset="utf-8" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no"
      />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <link rel="icon" type="image/png" href="favicon.png" />
      <title>Restó APP</title>
    </head>
    <body class="home-page">
      <Header :isRestoCompleto="!firstTime" ></Header>
      <div class="col-lg-8 mx-auto p-3 py-md-5">
        <main>
       

          <div class="row">
    <div class="col-2"  >
      <a href="#"   @click="goToPage('RegistrarMesa', $event)" v-if="!firstTime">
      <p class="h5 mb-2"> <b-icon-arrow-left></b-icon-arrow-left>Atrás</p>
    </a>
    </div>
    <div class="col-8">
      <h3>Horarios de cocina</h3>
    </div>
    <div class="col-2">
      <a href="#" v-on:click="guardarCambios()" v-if="!firstTime">
      <p class="h5 mb-2">Siguiente<b-icon-arrow-right></b-icon-arrow-right></p>
    </a>
    </div>
  </div>


          <hr class="" />

          <form v-on:submit.prevent="guardarCambios">
            <div class="mb-4 row">
              <label class="col-sm-3 col-form-label">Horario de almuerzo</label>
              <div class="col-sm-3">
                <select
                  class="form-control"
                  @change="onChange($event)"
                  v-model="form.horarioAperturaAlmuerzo"
                >
                  <option
                    v-for="(horarioApertura, index) in horariosFiltrados"
                    :key="index"
                    :value="horarioApertura"
                  >
                    {{ horarioApertura }} hrs
                  </option>
                </select>

           

              </div>
              <div class="col-sm-3">
                <select
                  class="form-control"
                  v-model="form.horarioCierreAlmuerzo"
                  @change="onChange($event)"
                >
                  <option
                    v-for="(horarioCierre, index) in horariosCierreAlmuerzo"
                    :key="index"
                    :value="horarioCierre"
                  >
                    {{ horarioCierre }} hrs
                  </option>
                </select>
              </div>
            </div>

         

            <div class="mb-4 row" style="justify-content: center;">
              <div class="col-1">
              <label class="col-form-label">Lunes</label>
             
                <div class="text-center">
                  <input
                    class="form-check-input"
                    v-model="form.lunesMediodia"
                    type="checkbox"
                    role="switch"
                    id="switchPets"
                  />
                </div>
              </div>

              <div class="col-1">
              <label class="col-form-label">Martes</label>
             
                <div class="text-center">
                  <input
                    class="form-check-input"
                    v-model="form.martesMediodia"
                    type="checkbox"
                    role="switch"
                    id="switchPets"
                  />
                </div>
              </div>

              <div class="col-1">
              <label class="col-form-label">Miercoles</label>
             
                <div class="text-center">
                  <input
                    class="form-check-input"
                    v-model="form.miercolesMediodia"
                    type="checkbox"
                    role="switch"
                    id="switchPets"
                  />
                </div>
              </div>

              <div class="col-1">
              <label class="col-form-label">Jueves</label>
             
                <div class="text-center">
                  <input
                    class="form-check-input"
                    v-model="form.juevesMediodia"
                    type="checkbox"
                    role="switch"
                    id="switchPets"
                  />
                </div>
              </div>

              <div class="col-1">
              <label class="col-form-label">Viernes</label>
             
                <div class="text-center">
                  <input
                    class="form-check-input"
                    v-model="form.viernesMediodia"
                    type="checkbox"
                    role="switch"
                    id="switchPets"
                  />
                </div>
              </div>

              <div class="col-1">
              <label class="col-form-label">Sabado</label>
             
                <div class="text-center">
                  <input
                    class="form-check-input"
                    v-model="form.sabadoMediodia"
                    type="checkbox"
                    role="switch"
                    id="switchPets"
                  />
                </div>
              </div>
              <div class="col-1">
              <label class="col-form-label">Domingo</label>
             
                <div class="text-center">
                  <input
                    class="form-check-input"
                    v-model="form.domingoMediodia"
                    type="checkbox"
                    role="switch"
                    id="switchPets"
                  />
                </div>
              </div>
            </div>
            

            <div class="mb-4 row">
              <label class="col-sm-3 col-form-label">Horario de cena</label>
              <div class="col-sm-3">
                <select
                  class="form-control"
                  @change="onChange($event)"
                  v-model="form.horarioAperturaCena"
                >
                  <option
                    v-for="(horarioApertura, index) in horariosAperturaCena"
                    :key="index"
                    :value="horarioApertura"
                  >
                    {{ horarioApertura }} hrs
                  </option>
                </select>
              </div>
              <div class="col-sm-3">
                <select class="form-control" v-model="form.horarioCierreCena">
                  <option
                    v-for="(horarioCierre, index) in horariosCierreCena"
                    :key="index"
                    :value="horarioCierre"
                  >
                    {{ horarioCierre }} hrs
                  </option>
                </select>
              </div>
            </div>


            <div class="mb-4 row" style="justify-content: center;">
              <div class="col-1">
              <label class="col-form-label">Lunes</label>
             
                <div class="text-center">
                  <input
                    class="form-check-input"
                    v-model="form.lunesNoche"
                    type="checkbox"
                    role="switch"
                    id="switchPets"
                  />
                </div>
              </div>

              <div class="col-1">
              <label class="col-form-label">Martes</label>
             
                <div class="text-center">
                  <input
                    class="form-check-input"
                    v-model="form.martesNoche"
                    type="checkbox"
                    role="switch"
                    id="switchPets"
                  />
                </div>
              </div>

              <div class="col-1">
              <label class="col-form-label">Miercoles</label>
             
                <div class="text-center">
                  <input
                    class="form-check-input"
                    v-model="form.miercolesNoche"
                    type="checkbox"
                    role="switch"
                    id="switchPets"
                  />
                </div>
              </div>

              <div class="col-1">
              <label class="col-form-label">Jueves</label>
             
                <div class="text-center">
                  <input
                    class="form-check-input"
                    v-model="form.juevesNoche"
                    type="checkbox"
                    role="switch"
                    id="switchPets"
                  />
                </div>
              </div>

              <div class="col-1">
              <label class="col-form-label">Viernes</label>
             
                <div class="text-center">
                  <input
                    class="form-check-input"
                    v-model="form.viernesNoche"
                    type="checkbox"
                    role="switch"
                    id="switchPets"
                  />
                </div>
              </div>

              <div class="col-1">
              <label class="col-form-label">Sabado</label>
             
                <div class="text-center">
                  <input
                    class="form-check-input"
                    v-model="form.sabadoNoche"
                    type="checkbox"
                    role="switch"
                    id="switchPets"
                  />
                </div>
              </div>
              <div class="col-1">
              <label class="col-form-label">Domingo</label>
             
                <div class="text-center">
                  <input
                    class="form-check-input"
                    v-model="form.domingoNoche"
                    type="checkbox"
                    role="switch"
                    id="switchPets"
                  />
                </div>
              </div>
            </div>


            <div class="d-grid d-md-flex justify-content-md-center">
              <button class="btn btn-primary" type="submit" :disabled="isFormEnable" v-if="!firstTime">
                Guardar cambios
              </button>
              <button class="btn btn-primary" @click="goToPage('RegistrarMesa', $event)" v-if="firstTime">
                Anterior
              </button>
              <button class="btn btn-primary" type="submit" v-if="firstTime">
                Siguiente
              </button>
            </div>
          </form>
          <PopUp :show="success" @close="success = false; if(firstTime)goToPageFirstTime('Imagenes')">
            <template #body>
              <p>{{ success_msg }}</p>
            </template>
          </PopUp>
          <PopUp :show="error" @close="error = false">
            <template #body>
              <p>{{ error_msg }}</p>
            </template>
          </PopUp>
        </main>
        <Footer />
      </div>
    </body>
  </html>
</template>

<script>
import axios from "axios";
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import PopUp from "../components/PopUp.vue";
import { cloneDeep, isEqual } from 'lodash'
export default {
  name: "Horarios",
  components: { Header, Footer, PopUp },
  
  data: function () {
    return {
      firstTime: false,
      restaurante: Object,
      originalForm: {},
      form: {
        horarioAperturaAlmuerzo: "",
        horarioCierreAlmuerzo: "",
        horarioAperturaCena: "",
        horarioCierreCena: "",
        lunesMediodia: "",
        lunesNoche: "",
        martesMediodia: "",
        martesNoche: "",
        miercolesMediodia: "",
        miercolesNoche: "",
        juevesMediodia: "",
        juevesNoche: "",
        viernesMediodia: "",
        viernesNoche: "",
        sabadoMediodia: "",
        sabadoNoche: "",
        domingoMediodia: "",
        domingoNoche: "",
      },
      
      horariosApertura: [
        6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16
      ],
      
      horariosAperturaCenaDefault: [
       18,19,20,21,22,23
      ],

      horariosCierreAlmuerzo: new Array(),
      horariosAperturaCena: new Array(),
      horariosCierreCena: new Array(),
      error: false,
      error_msg: "",
      success: false,
      success_msg: "",
    };
  },
  beforeMount() {
    this.cargarHorarios();
  },
  computed: {
    isFormEnable() {
      // check if it's original value
      if (!isEqual(this.form, this.originalForm)) return false;

      return true;
    },
    horariosFiltrados() {
        return this.horariosApertura.filter(horario => horario > 12);
    }
  },
  methods: {
    cargarHorarios() {
      this.horariosAperturaCena=this.horariosAperturaCenaDefault;
      let mail = localStorage.getItem("email");
      axios
        .get("/horarios/" + mail)
        .then((data) => {
          if (data.status == 200) {
            if (data.data && data.data.horarios.length > 0) {
              this.cargarHorariosCierreAlmuerzo();
              this.form.horarioAperturaAlmuerzo = data.data.horarios[0];

              if(data.data.horarios[0]>18){
                this.form.horarioAperturaCena=data.data.horarios[0];
                this.form.horarioCierreCena =
                data.data.horarios[data.data.horarios.length - 1];
                this.cargarHorariosCierreCena();
                return
              }

              console.log(this.form.horarioAperturaAlmuerzo)
              this.form.horarioCierreAlmuerzo = this.getHorarioCierreAlmuerzo(
                data.data.horarios
              );
              this.form.horarioAperturaCena = this.getHorarioInicioCena(
                data.data.horarios
              );
              this.form.horarioCierreCena =
                data.data.horarios[data.data.horarios.length - 1];
              this.cargarHorariosCierreCena();
              this.cargarHorariosAperturaCena();
              this.originalForm = cloneDeep(this.form);
            }
          }
        })
        .catch(() => {
          this.error = true;
          this.error_msg =
            "No se ha podido actualizar la informacion. Vuelva a intentar mas tarde";
        });



        axios
        .get("/horarios-detalle/" + mail)
        .then((data) => {
          if (data.status == 200) {
          if(data.data){
            data.data.forEach(element => {
              if(element.mediodia_noche=="N"){
             this.form[element.dia.toLowerCase()+"Noche"]=element.dia;
              }else{
             this.form[element.dia.toLowerCase()+"Mediodia"]=element.dia;
              }

            });
          }
          }
        })
        .catch(() => {
          this.error = true;
          this.error_msg =
            "No se ha podido actualizar la informacion. Vuelva a intentar mas tarde";
        });

    },
    onChange() {
      if (this.form.horarioAperturaAlmuerzo !== "") {
        this.cargarHorariosCierreAlmuerzo();
      }
      if (this.form.horarioCierreAlmuerzo !== "") {
        this.cargarHorariosAperturaCena();
        if (this.form.horarioCierreAlmuerzo + 1 >= this.form.horarioAperturaCena) {
          this.form.horarioAperturaCena = "";
          this.form.horarioCierreCena = "";
        }
      }

      if (this.form.horarioAperturaCena !== "") {
        this.cargarHorariosCierreCena();
      }
    },

    cargarHorariosCierreAlmuerzo() {
      this.horariosCierreAlmuerzo = new Array();
      for (let i = this.form.horarioAperturaAlmuerzo; i < 17; i++) {
        if(i!="" && i> 5){
          this.horariosCierreAlmuerzo.push(i);
        }

      }
    },

    cargarHorariosAperturaCena() {
      this.horariosAperturaCena = new Array();
      for (let i = this.form.horarioCierreAlmuerzo + 2; i < 24; i++) {
        if(i>13){
          this.horariosAperturaCena.push(i);
        }

      }
    },

    cargarHorariosCierreCena() {
      this.horariosCierreCena = new Array();
      for (let i = this.form.horarioAperturaCena; i < 24; i++) {
        if(i>13){
          this.horariosCierreCena.push(i);
        }
       
      }
    },

    getHorarioCierreAlmuerzo(horarios) {
      let horarioAnterior = horarios[0];
      for (var i = 1; i < horarios.length; i++) {
        if (horarios[i] != horarioAnterior + 1) {
          break;
        }
        horarioAnterior++;
      }
      return horarioAnterior;
    },

    getHorarioInicioCena(horarios) {
      let horarioAnterior = horarios[horarios.length - 1];
      for (var i = horarios.length - 2; i >= 0; i--) {
        if (horarios[i] != horarioAnterior - 1) {
          break;
        }
        horarioAnterior--;
      }
      return horarioAnterior;
    },

    guardarCambios() {
      let horariosNoche = new Array();
      let horariosAlmuerzo = new Array();
      let horarios = new Array();
      if (
        this.form.horarioAperturaAlmuerzo !== "" &&
        this.form.horarioCierreAlmuerzo !== ""
      ) {
        for (
          let i = this.form.horarioAperturaAlmuerzo;
          i <= this.form.horarioCierreAlmuerzo;
          i++
        ) {
          horariosAlmuerzo.push(i);
          horarios.push(i);
        }
      }
      if (this.form.horarioAperturaCena !== "" && this.form.horarioCierreCena !== "") {
        for (
          let i = this.form.horarioAperturaCena;
          i <= this.form.horarioCierreCena;
          i++
        ) {
          horariosNoche.push(i);
          horarios.push(i);
        }
      }
      let diasMediodia=[];

      if (this.form.lunesMediodia !== "" && this.form.lunesMediodia) {
        diasMediodia.push("LUNES");
      }
      if (this.form.martesMediodia !== "" && this.form.martesMediodia) {
        diasMediodia.push("MARTES");
      }
      if (this.form.miercolesMediodia !== "" && this.form.miercolesMediodia) {
        diasMediodia.push("MIERCOLES");
      }
      if (this.form.juevesMediodia !== "" && this.form.juevesMediodia) {
        diasMediodia.push("JUEVES");
      }
      if (this.form.viernesMediodia !== "" && this.form.viernesMediodia) {
        diasMediodia.push("VIERNES");
      }
      if (this.form.sabadoMediodia !== "" && this.form.sabadoMediodia) {
        diasMediodia.push("SABADO");
      }
      if (this.form.domingoMediodia !== "" && this.form.domingoMediodia) {
        diasMediodia.push("DOMINGO");
      }

      let diasNoche=[];
      if (this.form.lunesNoche !== "" && this.form.lunesNoche) {
        diasNoche.push("LUNES");
      }
      if (this.form.martesNoche !== "" && this.form.martesNoche) {
        diasNoche.push("MARTES");
      }
      if (this.form.miercolesNoche !== "" && this.form.miercolesNoche) {
        diasNoche.push("MIERCOLES");
      }
      if (this.form.juevesNoche !== "" && this.form.juevesNoche) {
        diasNoche.push("JUEVES");
      }
      if (this.form.viernesNoche !== "" && this.form.viernesNoche) {
        diasNoche.push("VIERNES");
      }
      if (this.form.sabadoNoche !== "" && this.form.sabadoNoche) {
        diasNoche.push("SABADO");
      }
      if (this.form.domingoNoche !== "" && this.form.domingoNoche) {
        diasNoche.push("DOMINGO");
      }

      if(horariosNoche.length==0 && horariosAlmuerzo.length==0){
        this.error = true;
        this.error_msg =
          "Debe seleccionar al menos un horario de cocina";
        return;
      }

      if(diasMediodia.length==0 && diasNoche.length==0){
        this.error = true;
        this.error_msg =
          "Debe seleccionar al menos un dia de cocina";
        return;
      }

      let json = {
        horariosNoche: horariosNoche,
        horariosAlmuerzo: horariosAlmuerzo,
        horarios: horarios,
        diasMediodia:diasMediodia,
        diasNoche:diasNoche
      };
 
      axios
        .post("/agregarHorarios", json)
        .then((data) => {
          if (data.status == 200) {
            this.success = true;
            this.success_msg = "Se ha logrado guardar los horarios de cocina con exito";
            this.cargarHorarios();
          } else {
            this.error = true;
            this.error_msg =
              " No se ha podido guardar los cambios. Intente nuevemente mas tarde";
          }
        });
    },
    goToPageFirstTime(page) {
      this.$router.push({ name: page, params: { firstTime: true } });
    },
    goToPage(page, $event) {
      this.$router.push({ name: page});
      $event?.preventDefault();
    },
  },
};
</script>

<style scoped>
@import url("https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css");
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap");

:host {
  --main-color: #0047b3;
  --second-color: #0198f3;
  --grey-color: #f5f8fa;
  --border-radius-1: 9px;
  --border-radius-2: 6px;
}
body {
  font-family: "Inter", sans-serif;
  color: #083744;
  font-size: 14px;
  height: 100%;
}
#tablas {
  display: flex;
}
.btn-primary{
  margin: 15px;
}
</style>
